
<template>
    <div class="slider slider5">
        <div class="icon d-flex align-items-center justify-content-center">
            <div class="line-fl"></div>
            <div class="icon-list d-flex">
                <div class="img-size" v-for="icon in iconList" :key="icon.id" @click="handleIcon(icon)">
                    <img :src="iconActive === icon.id ? icon.imgActive : icon.img" class="img-size cursor" />
                </div>
            </div>
            <div class="line-fr"></div>
        </div>

        <div class="role-list">
            <div class="cnt">
                <img :src="imgUrl" alt="" class="img-text r-img-size">
                <img :src="roleUrl" alt="" class="role-img-text r-img-size">
                <div class="video">
                    <video class="vd-video" muted autoplay loop :src="videoUrl" v-if="flag"></video>
                </div>
                <div class="tt-text"></div>
            </div>
        </div>
        <!-- avatar -->
        <div class="avatar">
            <div v-for="(avatarItem, aIndex) in avatarList" :key="aIndex">
                <div v-if="iconActive === avatarItem.id" class="d-flex align-items-center">
                    <div v-for="(aItem, aImgIndex) in avatarItem.list" :key="aImgIndex" class="mr-16"
                        @click="handleAvatar(aItem)">
                        <img :src="avatarActive === aItem.aId ? aItem.imgActive : aItem.img" alt=""
                            class="avatar-size  cursor">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            timer: null,//刚开始的时候令timer的初始值等于null
            hoverImg: 0,
            videoUrl: "https://resource-mp4.ujoygames.com/qyhx/job/video_job_1.mov",
            iconActive: 1,
            avatarActive: 0,
            iconList: [
                {
                    id: 1,
                    img: require('../../assets/img/m5/icon/1-0.png'),
                    imgActive: require('../../assets/img/m5/icon/1-0c.png'),

                },
                {
                    id: 2,
                    img: require('../../assets/img/m5/icon/2-0.png'),
                    imgActive: require('../../assets/img/m5/icon/2-0c.png'),

                },
                {
                    id: 3,
                    img: require('../../assets/img/m5/icon/3-0.png'),
                    imgActive: require('../../assets/img/m5/icon/3-0c.png'),

                },
                {
                    id: 4,
                    img: require('../../assets/img/m5/icon/4-0.png'),
                    imgActive: require('../../assets/img/m5/icon/4-0c.png'),

                },
            ],
            avatarList: [
                {
                    id: 1,
                    list: [
                        {
                            aId: 1,
                            img: require('../../assets/img/m5/user-avtar/1-1.png'),
                            imgActive: require('../../assets/img/m5/user-avtar/1-1c.png'),
                        },
                        {
                            aId: 2,
                            img: require('../../assets/img/m5/user-avtar/1-2.png'),
                            imgActive: require('../../assets/img/m5/user-avtar/1-2c.png'),
                        },
                        {
                            aId: 3,
                            img: require('../../assets/img/m5/user-avtar/1-3.png'),
                            imgActive: require('../../assets/img/m5/user-avtar/1-3c.png'),
                        }
                    ]
                },
                {
                    id: 2,
                    list: [
                        {
                            aId: 1,
                            img: require('../../assets/img/m5/user-avtar/2-1.png'),
                            imgActive: require('../../assets/img/m5/user-avtar/2-1c.png'),
                        },
                        {
                            aId: 2,
                            img: require('../../assets/img/m5/user-avtar/2-2.png'),
                            imgActive: require('../../assets/img/m5/user-avtar/2-2c.png'),
                        }
                    ]
                },
                {
                    id: 3,
                    list: [
                        {
                            aId: 1,
                            img: require('../../assets/img/m5/user-avtar/3-1.png'),
                            imgActive: require('../../assets/img/m5/user-avtar/3-1c.png'),
                        },
                        {
                            aId: 2,
                            img: require('../../assets/img/m5/user-avtar/3-2.png'),
                            imgActive: require('../../assets/img/m5/user-avtar/3-2c.png'),
                        }
                    ]
                },
                {
                    id: 4,
                    list: [
                        {
                            aId: 1,
                            img: require('../../assets/img/m5/user-avtar/4-1.png'),
                            imgActive: require('../../assets/img/m5/user-avtar/4-1c.png'),
                        }
                    ]
                }
            ],
            imgUrl: require('../../assets/img/m5/bg-1-0.png'),
            roleUrl: require('../../assets/img/m5/role-1-0.png'),
            flag: true
        }
    },
    created() {
        this.timer = setInterval(() => {
            this.hoverImg++;

            this.iconActive = this.hoverImg
            this.imgUrl = require(`../../assets/img/m5/bg-${this.hoverImg}-0.png`)
            this.roleUrl = require(`../../assets/img/m5/role-${this.hoverImg}-0.png`)
            this.videoUrl = `https://resource-mp4.ujoygames.com/qyhx/job/video_job_${this.hoverImg}.mov`

            if (this.hoverImg == 4) {
                this.hoverImg = 0;
            }
        }, 5000);
    },
    methods: {
        restore() {
            this.timer = setInterval(() => {
                this.hoverImg++;
                if (this.hoverImg == 3) {
                    this.hoverImg = 0;
                }
            }, 1000);
        },

        handleIcon(item) {
            this.avatarActive = 0
            this.iconActive = item.id
            this.imgUrl = require(`../../assets/img/m5/bg-${item.id}-0.png`)
            this.roleUrl = require(`../../assets/img/m5/role-${item.id}-0.png`)
            this.videoUrl = `https://resource-mp4.ujoygames.com/qyhx/job/video_job_${item.id}.mov`
            this.flag = true

        },
        handleAvatar(aItem) {
            console.log('当前点击的iconID',this.iconActive, aItem.aId)
            this.avatarActive = aItem.aId

            this.imgUrl = require(`../../assets/img/m5/bg-${this.iconActive}-${aItem.aId}.png`)
            this.roleUrl = require(`../../assets/img/m5/role-${this.iconActive}-${aItem.aId}.png`)
            this.videoUrl = `https://resource-mp4.ujoygames.com/qyhx/job/video_job_${this.iconActive}_${aItem.aId}.mp4`
            this.flag = true


            // this.videoUrl = ""
            // this.flag = false



            // 将定时器给关闭
            clearInterval(this.timer);
            this.timer = null;

        }
    },
    beforeDestroy() {
        // 在页面注销前，将定时器给关闭
        clearInterval(this.timer);
        this.timer = null;
    }
}
</script>
<style lang="scss" scoped>
.slider5 {
    background: url("../../assets/img/m5/bg.png") no-repeat top;
    background-size: cover;
    width: 100%;
    height: 100%;
    position: relative;

    .icon {
        margin: 0 auto;
        position: absolute;
        top: 30px;
        z-index: 9;
        left: 50%;
        transform: translate(-50%, 0);

        img {
            display: block;
        }

        .line-fl {
            background: url("../../assets/img/m5/line-fl.png") no-repeat top;
            background-size: 100% 100%;
            width: 114px;
            height: 13px;
        }

        .line-fr {
            background: url("../../assets/img/m5/line-fr.png") no-repeat top;
            background-size: 100% 100%;
            width: 114px;
            height: 13px;
        }

        .img-size {
            width: 141px;
            height: 141px;
        }


    }

    .role-list {
        position: absolute;
        bottom: 0;
        z-index: 0;
        width: 100%;
        height: 100%;

        .cnt {
            position: relative;
            width: 100%;
            height: 100%;

            .r-img-size {
                width: 1920px;
                height: 1080px;
                display: block;
            }

            .img-text {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            .role-img-text {
                position: absolute;
                bottom: 0;
            }

            .video {
                width: 369px;
                height: 220px;
                background: url("../../assets/img/m5/vd.png") no-repeat top;
                background-size: 100% 100%;
                position: absolute;
                bottom: 365px;
                left: 370px;
                display: flex;
                align-items: center;
                justify-content: center;

                .vd-video {
                    width: 354px;
                    height: 199px;
                }
            }

            .tt-text {
                width: 131px;
                height: 25px;
                background: url("../../assets/img/m5/tt-text.png") no-repeat top;
                background-size: 100% 100%;
                position: absolute;
                bottom: 305px;
                left: 370px;
            }
        }

    }

    .avatar {
        position: absolute;
        bottom: 142px;
        left: 370px;

        .avatar-size {
            width: 144px;
            height: 126px;
            display: block;
        }
    }
}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
    .slider5 {
        .role-img-text {
            left: 50%;
            transform: translate(-50%, 0);
        }

        .img-size {
            width: 120px !important;
            height: 120px !important;
        }

        .r-img-size {
            // width:1632px !important;
            // height:918px !important;
            width: 1536px !important;
            height: 864px !important;
        }

        .video {
            width: 314px !important;
            height: 184px !important;
            bottom: 310px !important;
            left: 480px !important;

            .vd-video {
                width: 300px !important;
                height: 170px !important;
            }
        }

        .tt-text {
            width: 111px !important;
            height: 21px !important;
            bottom: 270px !important;
            left: 480px !important;


        }

        .avatar {
            left: 480px !important;

            .avatar-size {
                width: 122px !important;
                height: 103px !important;
            }
        }


    }

}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/slider5.vue